import type { Extension, Mark, Node } from '@tiptap/core';
import Color from '@tiptap/extension-color';
import FontFamily from '@tiptap/extension-font-family';
import Highlight from '@tiptap/extension-highlight';
import Link from '@tiptap/extension-link';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import { Table } from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyle } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { FontSize, LinkBubbleMenuHandler, ResizableImage } from 'mui-tiptap';

const CustomLinkExtension = Link.extend({
  inclusive: false,
});

const RichTextExtensions: (Extension | Mark | Node)[] = [
  StarterKit.configure({
    link: false,
    underline: false,
  }),
  Superscript,
  Subscript,
  Underline,
  TextAlign.configure({
    types: ['heading', 'paragraph', 'image'],
  }),
  FontFamily,
  TextStyle,
  FontSize,
  TaskList,
  TaskItem.configure({
    nested: true,
  }),
  Highlight.configure({ multicolor: true }),
  Color,
  Table,
  ResizableImage.configure({
    allowBase64: true,
  }),
  TableRow,
  TableCell,
  TableHeader,
  LinkBubbleMenuHandler,
  CustomLinkExtension.configure({
    // autolink is generally useful for changing text into links if they
    // appear to be URLs (like someone types in literally "example.com"),
    // though it comes with the caveat that if you then *remove* the link
    // from the text, and then add a space or newline directly after the
    // text, autolink will turn the text back into a link again. Not ideal,
    // but probably still overall worth having autolink enabled, and that's
    // how a lot of other tools behave as well.
    autolink: true,
    linkOnPaste: true,
    openOnClick: false,
  }),
];

export default RichTextExtensions;
